import React, { useEffect, useState } from 'react';
import { fetchLocations } from '../contentfulLocations';
import Button from './Button';

const Locations = ({ continent }) => {
    const [locations, setLocations] = useState([]);

    useEffect(() => {
        fetchLocations(continent).then((response) => {
            setLocations(response.items);
        }).catch(console.error);
    }, [continent]);

    return (
        <section className={continent ? 'bg-grey' : 'bg-white'}>
            <div className='grid grid-cols-1 lg:grid-cols-12 gap-10 mx-auto'>
                <div className='col-span-full lg:col-span-10 lg:col-start-2 lg:col-end-12'>
                    <h2 className='text-3xl mb-6 pb-10 text-center'>
                        {continent ? `Our presence in ${continent}` : 'Our Locations'}
                    </h2>
                    <div className={`grid grid-cols-1 md:grid-cols-2 ${continent ? 'lg:grid-cols-6' : 'lg:grid-cols-3'} gap-10`}>
                        {locations.map((entry, index) => (
                            <div key={index} className='bg-light-blue overflow-hidden'>
                                <div className='location-img' style={{
                                    backgroundImage: `url(${entry.fields.officeImage.fields.file.url})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    height: '250px'
                                }}></div>
                                <div className='p-6'>
                                    <h3 className='text-xl font-bold'>{`${entry.fields.officeCity}, ${entry.fields.officeCountry}`}</h3>
                                    {continent && (
                                        <p className='office-address' style={{ marginTop: '0.3rem', marginBottom: '1rem' }}>
                                            {entry.fields.description}
                                        </p>
                                    )}
                                    {!continent && (
                                        <>
                                            <p className='regulator'>
                                                {entry.fields.regulatedOffice ? `Regulator: ${entry.fields.officeRegulator}` : entry.fields.officeRegulator}
                                                {entry.fields.officeRegulatorIdentifierType && entry.fields.officeRegulatorIdentifierNumber && (
                                                    `. ${entry.fields.officeRegulatorIdentifierType}: ${entry.fields.officeRegulatorIdentifierNumber}`
                                                )}
                                            </p>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span style={{ fontWeight: '300', paddingTop: '0.5rem' }}>
                                                    Tel: <a href={`tel:${entry.fields.officePhoneNumber}`} style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">{entry.fields.officePhoneNumber}</a>
                                                </span>
                                                <span style={{ fontWeight: '300', paddingTop: '0.5rem' }}>
                                                    Email: <a href={`mailto:${entry.fields.officeEmailAddress}`} style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">{entry.fields.officeEmailAddress}</a>
                                                </span>
                                                <span style={{ fontWeight: '300', paddingTop: '0.5rem' }}>
                                                    Website: <a href={entry.fields.officeWebsite.startsWith('http') ? entry.fields.officeWebsite : `http://${entry.fields.officeWebsite}`} style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">{entry.fields.officeWebsite}</a>
                                                </span>
                                            </div>
                                        </>
                                    )}
                                    {continent && (
                                        <a href={`/locations/${entry.fields.officeCity.toLowerCase().replace(/ /g, '-')}`} style={{ display: 'inline-block', fontWeight: '300', textDecoration: 'underline' }}>
                                            Learn more about our {entry.fields.officeCity} location
                                        </a>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className='col-span-full flex justify-center'>
                        {continent === 'Asia' && (
                            <Button color="holborn-green" href="/who-we-are/our-locations/" type="submit" className="border-2 border-holborn-blue py-2 px-8 rounded-3xl transition duration-500 hover:bg-holborn-blue hover:text-white">
                                View our global locations
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Locations;